module.exports = "https://web-assets.ifttt.com/packs/media/partners/profile-6f2364dc.svg";